import { Button, ButtonProps, Box, BoxProps } from '@mui/material';
import React, { forwardRef, ElementType } from 'react';

export interface ShortcutProps extends Omit<ButtonProps, 'variant' | 'color'> {}

/**
 * Shortcut is a proxy component to <Button variant="shortcut" />
 */
export const Shortcut: React.FC<ShortcutProps> = forwardRef((props, ref) => {
  return <Button {...props} ref={ref} variant="shortcut" />;
});

export interface ShortcutWrapperProps extends BoxProps<ElementType> {}

/**
 * Wrapper container for multiple Shortcuts
 */
export const ShortcutWrapper: React.FC<ShortcutWrapperProps> = forwardRef(({ sx, children, ...rest }, ref) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'center' },
        columnGap: { xs: 2, md: 3.5, lg: 6.5 },
        rowGap: 2,
        ...sx,
      }}
      ref={ref}
      {...rest}
    >
      {children}
    </Box>
  );
});
